import { render, staticRenderFns } from "./selectGroupGoods.vue?vue&type=template&id=685cf07c&scoped=true"
import script from "./selectGroupGoods.vue?vue&type=script&lang=js"
export * from "./selectGroupGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685cf07c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685cf07c')) {
      api.createRecord('685cf07c', component.options)
    } else {
      api.reload('685cf07c', component.options)
    }
    module.hot.accept("./selectGroupGoods.vue?vue&type=template&id=685cf07c&scoped=true", function () {
      api.rerender('685cf07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonAdd/selectGroupGoods.vue"
export default component.exports